import { Helmet } from 'react-helmet-async';
import {
  buildPageSeoDescriptors,
  type PageMeta,
  type PageSeoOptions,
  type PrerenderHeadElement,
} from '../../lib/seo';

export type PageSeoProps = PageSeoOptions & {
  meta: PageMeta;
};

function renderElement(element: PrerenderHeadElement, index: number) {
  if (element.type === 'meta') {
    const key = element.props.name ?? element.props.property ?? index;
    return <meta key={key} {...element.props} />;
  }
  if (element.type === 'link') {
    return <link key={`${element.props.rel}-${element.props.href}`} {...element.props} />;
  }
  return (
    <script key={element.children.slice(0, 32)} type={element.props.type}>
      {element.children}
    </script>
  );
}

export function PageSeo({ meta, ...options }: PageSeoProps) {
  // Prerender uses buildPrerenderHead for <head>; skip Helmet during SSR renderToString.
  if (typeof window === 'undefined') return null;

  const { title, elements } = buildPageSeoDescriptors(meta, options);

  return (
    <Helmet>
      <title>{title}</title>
      {elements.map(renderElement)}
    </Helmet>
  );
}
